<template>
  <div class="image-selection">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="950px"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-card outlined>
          <v-card-text
            v-bind="attrs"
            v-on="on"
          >
            <v-layout
              align-center
              justify-space-around
            >
              <v-img
                v-if="value"
                :src="previewUrl(value)"
                height="150"
                contain
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                  </v-row>
                </template>
              </v-img>

              <v-icon
                v-else
                size="150"
                color="grey lighten-3"
              >
                mdi-image-plus
              </v-icon>
            </v-layout>
          </v-card-text>
          <v-divider />
          <v-card-title class="py-2 justify-center">
            {{ title }}
          </v-card-title>
        </v-card>
      </template>

      <v-card>
        <v-card-title class="pa-3">
          Attach Image
          <v-spacer />
          <v-btn
            icon
            color="error"
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-app-bar
          dense
          flat
        >
          <v-row align="center">
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                id="search_image"
                v-model.trim="searchText"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                clearable
                outlined
                hide-details
                dense
                @input="search()"
              />
            </v-col>
            <v-spacer />
            <v-col
              cols="5"
              class="text-right"
            />
          </v-row>
        </v-app-bar>
        <v-divider />
        <v-card-text
          class="pa-4"
          style="min-height: 350px"
        >
          <v-layout
            v-show="totalPage === 0"
            fill-height
            align-center
            justify-space-around
          >
            <v-progress-circular
              v-show="loader"
              indeterminate
              color="primary"
            />
            <span
              v-show="!loader"
              class="subtitle-1"
            > No images found</span>
          </v-layout>
          <v-row v-show="totalPage != 0">
            <v-col
              v-for="image in images"
              :key="image.id"
              cols="12"
              sm="4"
              md="3"
              xl="2"
            >
              <v-card @click="setSelectedImg(image.id)">
                <div
                  v-show="selectedImgIds.includes(image.id)"
                  class="overlay-selected"
                />

                <v-img
                  :src="`${image.imgUrl}?v=${image.version}`"
                  aspect-ratio="1"
                  contain
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                      />
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-show="totalPage > 1">
          <v-row>
            <v-col>
              <v-pagination
                v-model="page"
                :length="totalPage"
                @input="getImages()"
              />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            outlined
            color="success"
            :disabled="selectedImgIds.length === 0"
            @click="updateImg()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { pagination, failure as failureMixin } from "@/mixins/common";
export default {
  name: "ImageSelection",
  mixins: [pagination, failureMixin],
  props: {
    title: {
      type: String,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    value: {
      type: [String, Object],
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      loader: false,
      searchText: null,
      page: 1,
      images: [],
      totalPage: 0,
      //baseURL: `${this.IMAGE_SERVER_API_URL}/api/v2/accounts/${this.accountId}/images`,
      selectedImgIds: []
    };
  },
  computed: {
  baseURL() {
    return `${this.IMAGE_SERVER_API_URL}/api/v2/accounts/${this.accountId}/images`;
  }
},
  watch: {
    dialog: {
      immediate: true,
      handler(v) {
        if (v) {
          this.init();
        }
      }
    }
  },
  methods: {
    getImages() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/images?page=${
        this.page - 1
      }&sort_key=tags&limit=${this.limit}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }

      this.$http.get(url).then(
        (res) => {
          this.images = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
          this.loader = false;
        }
      );
    },
    search() {
      if (this.searchText && this.searchText.length < 3) {
        return;
      }
      this.page = 1;
      this.getImages();
    },
    setSelectedImg(id) {
      const index = this.selectedImgIds.indexOf(id);
      if (index > -1) {
      this.selectedImgIds.splice(index, 1);
      } else {
      this.selectedImgIds.push(id);
      }
    },
    updateImg() {
      if (!this.selectedImgIds.length) return;

      // Requirement: Find the WHOLE object, not just the ID
      const selected = this.images.find(
        
      
      img => String(img.id) === String(this.selectedImgIds[0])
      );

      // Send the object so the parent has the UUID string
      this.$emit("attach", selected || null);
      this.close();
    },
    close() {
      this.dialog = false;
    },
    init() {
      this.selectedImgIds = [];
      this.searchText = null;
      this.search();
    },
    previewUrl(img) {
      if (!img) return null;
      return `${img.imgUrl}?v=${img.version || 1}`;
    }
  }
};
</script>

<style lang="scss">
.image-selection {
  .overlay-selected {
    background: #ee44aa;
    opacity: 0.5;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 9;
  }
}
</style>